import { observe, toJS } from 'mobx';
import { inject, observer } from 'mobx-react';
import * as moment from 'moment-timezone';
import * as React from 'react';
import { Prompt, withRouter } from 'react-router-dom';
import { DateTimePicker } from 'react-widgets';
import momentLocalizer from 'react-widgets-moment';
import 'react-widgets/dist/css/react-widgets.css';
import { Col, Form, FormGroup, Input, Label, Row, Table } from 'reactstrap';
import { TestsStore } from 'src/Stores/Tests/TestsStore';
import { UserStore } from 'src/Stores/User/UserStore';
import { IOptionFieldListItem } from '../../../../../Interfaces/AdminInterface';
import { IMudProperties, IProduct, ITest } from '../../../../../Interfaces/TestInterface';
import { IWell } from '../../../../../Interfaces/WellInterface';
import { EInput } from '../../../../EInput';
import Footer from '../../../../Footer';
import WorkflowHeader from '../../../WorkflowHeader';
const editableBlueStyle = {backgroundColor: '#DEEFF5'};

@inject('stores')
@observer
class MudProperties extends React.Component {
    public props: any;
    private test: ITest = new ITest();
    public TestsStore: TestsStore;
    private testDisposer: any;
    private well: IWell = new IWell();
    public WellsStore: any;
    private UserStore: UserStore;
    private wellDisposer: any;
    private mudProperties: IMudProperties = new IMudProperties();

    public state = {
        isDirty: false,
        mudProperties: this.mudProperties,
        mudPropertyOptions: [],
        mudTestOptions: [],
        mudTypes: [],
        propertyTypes: {
            'Oil Based Mud': [] as IOptionFieldListItem[],
            'Water Based Mud': [] as IOptionFieldListItem[],
        },
        saveClicked: false,
        test: this.test,
        weightingAgentOptions: [] as IProduct[],
        well: this.well
    };

    constructor(props: any) {
        super(props);

        moment.locale('en');
        momentLocalizer();

        this.TestsStore = this.props.stores.TestsStore;
        this.WellsStore = this.props.stores.WellsStore;
        this.UserStore = this.props.stores.UserStore;

        this.handleInputChange = this.handleInputChange.bind(this);
        this.handleDateTimeChange = this.handleDateTimeChange.bind(this);


        this.clearDisposers = this.clearDisposers.bind(this);
    }

    public componentDidMount() {

        this.getMudPropertyOptions();
        this.getMudTestOptions();
        this.getWeightingAgentOptions();
        this.loadMudTypeProperties();
        if ( this.props.stores.WellsStore.well && this.props.stores.TestsStore.test ) {
            const test: ITest = toJS(this.props.stores.TestsStore.test);
            this.fixTestProps(test);
            this.setState({
                test,
                well: toJS(this.props.stores.WellsStore.well)
            });
            
        } else {
            if ( ! this.TestsStore.test ) {
                this.TestsStore.getTestDetails(this.props.match.params.taskId, this.props.match.params.wellId);
            }
            if ( ! this.WellsStore.well ) {
                this.WellsStore.getWellDetails(this.props.match.params.wellId);
            }
        }
        this.createDisposers();
    }

    private fixTestProps = (test: ITest) => {
        if ( test.mudProperties.sampleSourceTime ) {
            test.mudProperties.otherTime = new Date(
                test.mudProperties.sampleSourceTime * 1000
            );
        } else {
            test.mudProperties.otherTime = new Date();
        }
        if (Number.isFinite(test.mudProperties.totalHardness)) {
            test.mudProperties.totalHardnessMl = test.mudProperties.totalHardness / 400;
        } else if(test.mudProperties.totalHardness === '') {
            test.mudProperties.totalHardnessMl = '';
        }

        if (Number.isFinite(test.mudProperties.calcium)) {
            test.mudProperties.calciumMl = test.mudProperties.calcium / 400;
        } else if(test.mudProperties.calcium === '') {
            test.mudProperties.calciumMl = '';
        }
        
        this.TestsStore.calculateFluidProperties(test);
    }

    public handleUserOverride = (event:any) => {
        const test = this.state.test;
        test.mudProperties[event.target.name] = !test.mudProperties[event.target.name];
        this.TestsStore.calculateFluidProperties(test);
        this.setState({
            isDirty: true,
            test,
        });
    }

    public createDisposers() {
        this.testDisposer = observe(this.TestsStore, 'test', (change: any) => {
            const test = toJS(change.newValue);
            this.fixTestProps(test);
            this.setState({
                test
            });
        });
        this.wellDisposer = observe(this.WellsStore, 'well', (change: any) => {
            const well = toJS(change.newValue);
            this.setState({
                well
            });
        });
    }

    public async componentWillUnmount() {
        this.clearDisposers();
    }

    public clearDisposers() {
        this.testDisposer();
        this.wellDisposer();
    }

    private loadMudTypeProperties = () => {
        const propertyTypes = this.state.propertyTypes;
        Promise.all([
            this.TestsStore.getOilFluidSubTypeOptions(),
            this.TestsStore.getWaterFluidSubTypeOptions()
        ]).then((data) => {
            if ( data[0] ) {
                propertyTypes['Oil Based Mud'] = data[0];
            }
            if ( data[1] ) {
                propertyTypes['Water Based Mud'] = data[1];
            }
            this.setState({propertyTypes});
        });
    }

    private getMudPropertyOptions() {
        return this.TestsStore.getMudPropertyOptions()
        .then(
            (data: any) => {
                this.setState({
                    mudPropertyOptions: data
                });
            }
        );
    }

    private getMudTestOptions() {
        return this.TestsStore.getMudTestOptions()
        .then(
            (data: any) => {
                this.setState({
                    mudTestOptions: data
                });
            }
        );
    }

    private getWeightingAgentOptions() {
        return this.TestsStore.getWeightingAgents(this.props.match.params.wellId)
            .then(
                (data: any) => {
                    this.setState({
                        weightingAgentOptions: data
                    });
                }
            );
    }

    private handleInputChange(event: any) {
        const test = this.state.test;

        if (event.target.name === 'calciumMl' || event.target.name === 'totalHardnessMl') {
            const field = event.target.name.replace('Ml', '');
            const value = Number(event.target.value);
            if(event.target.value === '') {
                test.mudProperties[field] = '';
            } else if (Number.isFinite(value)) {
                const fieldVal = value * 400;
                test.mudProperties[field] = Number(fieldVal.toFixed(4));
            } else {
                test.mudProperties[field] = '';
            }
            test.mudProperties[event.target.name] = event.target.value;
        }
        else {
            test.mudProperties[event.target.name] = event.target.value;
        }
        this.TestsStore.calculateFluidProperties(test);
        this.setState({
            isDirty: true,
            test
        });
    }

    private handleWeightingChange = (event: any) => {
        const weightingAgentId = event.target.value;
        const weightingAgent = this.state.weightingAgentOptions.find(wa => wa.id === weightingAgentId);
        const test = this.state.test;
        const mudProps = test.mudProperties;
        if (weightingAgent) {
            mudProps.weightingAgentId = weightingAgentId;
            mudProps.wghtMatlSg = Number(weightingAgent.specificGravity);
        }
        this.setState({
            isDirty: true,
            test
        });
    }

    private handleDateTimeChange(value: any) {
        const test = this.state.test;
        test.mudProperties.otherTime = value;
        this.setState({
            isDirty: true,
            test
        });
    }

    private otherTimeBlank = () => {
        return !this.state.test.mudProperties.otherTime;
    }

    private updateTestModel = () => {
        this.state.test.mudProperties.sampleSourceTime = moment(this.state.test.mudProperties.otherTime).unix();
        this.TestsStore.updateTestModel(this.state.test, this.props.match.params.wellId).then((test:any) => {
            if (test) {
                this.setState({
                    isDirty: false,
                });
            }
        });
    }

    private buttonNavigation = (event: any) => {
        const $target = event.target;

        if ( $target.name === 'previous' ) {
            this.props.history.push('/well/' + this.props.match.params.wellId + '/test/' + this.props.match.params.taskId + '/drillingpump');
        } else {
            this.props.history.push('/well/' + this.props.match.params.wellId + '/test/' + this.props.match.params.taskId + '/fluiddata/solidscontrol');
        }
    }

    public render() {
        // const showWeighted = this.state.test.weighted === false;
        const canEditSg = this.UserStore.hasPermission('Permissions.WellTests.EditSpecificGravity');
        return(
            <div className="MudProperties">
            <Prompt when={this.state.isDirty} message={"Changes have been made.\n\nPress Cancel then Press Save OR Press OK to continue without saving."} />
                <WorkflowHeader workflowHeaderItems={this.props.workflowHeaderItems} isInventoryReport={this.state.test.isInventoryReport}/>
                <Form>
                    <Row>
                        <Col md="6">
                            <h4>Mud Test Results</h4>
                            <Row>
                                <Col md="12">
                                    <FormGroup row={true} className="required" style={{'marginBottom': '.5rem !important'}}>
                                        <Col md="4">
                                            <Label style={{borderRadius: '4px'}}>Sample Source</Label>
                                        </Col>
                                        <Col md="8">
                                            <EInput
                                                type="text"
                                                id="sampleSource"
                                                name="sampleSource"
                                                value={this.state.test.mudProperties.sampleSource}
                                                required={true}
                                                onChange={this.handleInputChange}
                                            />
                                        </Col>
                                    </FormGroup>
                                </Col>
                                <Col md="12">
                                    <FormGroup row={true} className="required" style={{'marginBottom': '.5rem !important'}}>
                                        <Col md="4">
                                            <Label style={{borderRadius: '4px'}}>Sample Time</Label>
                                        </Col>
                                        <Col md="8" className={this.state.test.mudProperties.otherTime ? "" : "input-error"}>
                                            <DateTimePicker
                                                id="otherTime"
                                                name="otherTime"
                                                step={15}
                                                value={this.state.test.mudProperties.otherTime}
                                                onChange={this.handleDateTimeChange}
                                                disabled={this.state.well.wellStatus !== 'Active'}
                                            />
                                            {
                                                !this.state.test.mudProperties.otherTime &&
                                                <div className="error-messages">
                                                    <p className="validationError">This field is a required field</p>
                                                </div>
                                            }
                                        </Col>
                                    </FormGroup>
                                </Col>
                                <Col md="12">
                                    <FormGroup row={true}>
                                        <Label md="4">Flow Line Temp (Deg F)</Label>
                                        <Col md="8">
                                            <EInput
                                                type="text"
                                                id="flowLineTemp"
                                                name="flowLineTemp"
                                                data-validation="decimal"
                                                value={this.state.test.mudProperties.flowLineTemp}
                                                onChange={this.handleInputChange}
                                            />
                                        </Col>
                                    </FormGroup>
                                </Col>
                                <Col md="12">
                                    <FormGroup row={true}>
                                        <Label md="4">Mud Weight (ppg)</Label>
                                        <Col md="8">
                                            <EInput
                                                type="text"
                                                id="mudWeight"
                                                name="mudWeight"
                                                data-validation="decimal"
                                                value={this.state.test.mudProperties.mudWeight}
                                                onChange={this.handleInputChange}
                                            />
                                        </Col>
                                    </FormGroup>
                                </Col>
                                <Col md="6">
                                    <FormGroup row={true}>
                                        <Label md="4">Funnel Viscosity</Label>
                                        <Col md="8">
                                            <EInput
                                                type="text"
                                                id="funnelViscosity"
                                                name="funnelViscosity"
                                                value={this.state.test.mudProperties.funnelViscosity}
                                                onChange={this.handleInputChange}
                                            />
                                        </Col>
                                    </FormGroup>
                                </Col>
                                <Col md="6">
                                    <FormGroup row={true}>
                                        <Label md="4">Deg F (seq/qt)</Label>
                                        <Col md="8">
                                            <EInput
                                                type="text"
                                                id="funnelViscosityDefF"
                                                name="funnelViscosityDefF"
                                                value={this.state.test.mudProperties.funnelViscosityDefF}
                                                onChange={this.handleInputChange}
                                            />
                                        </Col>
                                    </FormGroup>
                                </Col>
                                <Col md="12">
                                    <hr/>
                                </Col>
                                <Col md="12">
                                    <Label style={{'fontSize': '125%'}}>RPM:</Label>
                                </Col>
                                <Col md="5">
                                    <Table>
                                        <thead>
                                            <tr>
                                                <th>Deg Fahrenheit</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr>
                                                <td>
                                                    <EInput
                                                        type="text"
                                                        id="rpmDegF"
                                                        name="rpmDegF"
                                                        data-validation="decimal"
                                                        value={this.state.test.mudProperties.rpmDegF}
                                                        onChange={this.handleInputChange}
                                                    />
                                                </td>
                                            </tr>
                                        </tbody>
                                    </Table>
                                </Col>
                                <Col md="7">
                                    <Table>
                                        <thead>
                                            <tr>
                                                <th className="align-center">600</th>
                                                <th className="align-center">300</th>                                                
                                                <th className="align-center">200</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr>
                                                <td>
                                                    <EInput
                                                        type="text"
                                                        id="rpmDegF600"
                                                        name="rpmDegF600"
                                                        data-validation="decimal"
                                                        value={this.state.test.mudProperties.rpmDegF600}
                                                        onChange={this.handleInputChange}
                                                    />
                                                </td>
                                                <td>
                                                    <EInput
                                                        type="text"
                                                        id="rpmDegF300"
                                                        name="rpmDegF300"
                                                        data-validation="decimal"
                                                        value={this.state.test.mudProperties.rpmDegF300}
                                                        onChange={this.handleInputChange}
                                                    />
                                                </td>
                                                <td>
                                                    <EInput
                                                        type="text"
                                                        id="rpmDegF200"
                                                        name="rpmDegF200"
                                                        data-validation="decimal"
                                                        value={this.state.test.mudProperties.rpmDegF200}
                                                        onChange={this.handleInputChange}
                                                    />
                                                </td>
                                            </tr>
                                        </tbody>
                                    </Table>
                                    <Table>
                                        <thead>
                                            <tr>
                                                <th className="align-center">100</th>
                                                <th className="align-center">6</th>
                                                <th className="align-center">3</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr>
                                                <td>
                                                    <EInput
                                                        type="text"
                                                        id="rpmDegF100"
                                                        name="rpmDegF100"
                                                        data-validation="decimal"
                                                        value={this.state.test.mudProperties.rpmDegF100}
                                                        onChange={this.handleInputChange}
                                                    />
                                                </td>
                                                <td>
                                                    <EInput
                                                        type="text"
                                                        id="rpmDegF6"
                                                        name="rpmDegF6"
                                                        data-validation="decimal"
                                                        value={this.state.test.mudProperties.rpmDegF6}
                                                        onChange={this.handleInputChange}
                                                    />
                                                </td>
                                                <td>
                                                    <EInput
                                                        type="text"
                                                        id="rpmDegF3"
                                                        name="rpmDegF3"
                                                        data-validation="decimal"
                                                        value={this.state.test.mudProperties.rpmDegF3}
                                                        onChange={this.handleInputChange}
                                                    />
                                                </td>
                                            </tr>
                                        </tbody>
                                    </Table>
                                </Col>
                                <Col md="12">
                                    <hr/>
                                </Col>
                                <Col md="5">
                                    <Table>
                                        <thead>
                                            <tr>
                                                <th style={{'color': 'white'}}>Gel Strength:</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr>
                                                <td><Label style={{'fontSize': '125%'}}>Gel Strength:</Label></td>
                                            </tr>
                                        </tbody>
                                    </Table>
                                </Col>
                                <Col md="7">
                                    <Table>
                                        <thead>
                                            <tr>
                                                <th className="align-center">10 Sec</th>
                                                <th className="align-center">10 Min</th>
                                                <th className="align-center">30 Min</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr>
                                                <td>
                                                    <EInput
                                                        type="text"
                                                        id="gelStrength10sec"
                                                        name="gelStrength10sec"
                                                        data-validation="decimal"
                                                        value={this.state.test.mudProperties.gelStrength10sec}
                                                        onChange={this.handleInputChange}
                                                    />
                                                </td>
                                                <td>
                                                    <EInput
                                                        type="text"
                                                        id="gelStrength10min"
                                                        name="gelStrength10min"
                                                        data-validation="decimal"
                                                        value={this.state.test.mudProperties.gelStrength10min}
                                                        onChange={this.handleInputChange}
                                                    />
                                                </td>
                                                <td>
                                                    <EInput
                                                        type="text"
                                                        id="gelStrength30min"
                                                        name="gelStrength30min"
                                                        data-validation="decimal"
                                                        value={this.state.test.mudProperties.gelStrength30min}
                                                        onChange={this.handleInputChange}
                                                    />
                                                </td>
                                            </tr>
                                        </tbody>
                                    </Table>
                                </Col>
                                <Col md="12">
                                    <hr/>
                                </Col>
                                <Col md="12">
                                    <Table>
                                        <thead>
                                            <tr>
                                                <th/>
                                                <th className="align-center">API</th>
                                                <th className="align-center">HTHP</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr>
                                                <td>Filtrate:</td>
                                                <td>
                                                    <EInput
                                                        type="text"
                                                        id="filtrateApi"
                                                        name="filtrateApi"
                                                        data-validation="decimal"
                                                        value={this.state.test.mudProperties.filtrateApi}
                                                        onChange={this.handleInputChange}
                                                    />
                                                </td>
                                                <td>
                                                    <EInput
                                                        type="text"
                                                        id="filtrateHthp"
                                                        name="filtrateHthp"
                                                        data-validation="decimal"
                                                        value={this.state.test.mudProperties.filtrateHthp}
                                                        onChange={this.handleInputChange}
                                                    />
                                                </td>
                                            </tr>
                                            <tr>
                                                <td>Cake Thickness API (1/32 in):</td>
                                                <td>
                                                    <EInput
                                                        type="text"
                                                        id="cakeThicknessApi"
                                                        name="cakeThicknessApi"
                                                        data-validation="integer"
                                                        value={this.state.test.mudProperties.cakeThicknessApi}
                                                        onChange={this.handleInputChange}
                                                    />
                                                </td>
                                                <td>
                                                    <EInput
                                                        type="text"
                                                        id="cakeThicknessHthp"
                                                        name="cakeThicknessHthp"
                                                        data-validation="decimal"
                                                        value={this.state.test.mudProperties.cakeThicknessHthp}
                                                        onChange={this.handleInputChange}
                                                    />
                                                </td>
                                            </tr>
                                            <tr>
                                                <td>Mud Temperature:</td>
                                                <td>
                                                    <EInput
                                                        type="text"
                                                        id="mudTempApi"
                                                        name="mudTempApi"
                                                        data-validation="decimal"
                                                        value={this.state.test.mudProperties.mudTempApi}
                                                        onChange={this.handleInputChange}
                                                    />
                                                </td>
                                                <td>
                                                    <EInput
                                                        type="text"
                                                        id="mudTempHthp"
                                                        name="mudTempHthp"
                                                        data-validation="decimal"
                                                        value={this.state.test.mudProperties.mudTempHthp}
                                                        onChange={this.handleInputChange}
                                                    />
                                                </td>
                                            </tr>
                                        </tbody>
                                    </Table>
                                </Col>
                                <Col md="12">
                                    <hr/>
                                </Col>
                                <Col md="5">
                                    <Table>
                                        <thead>
                                            <tr>
                                                <th style={{'color': 'white'}}>Retort Content (% by Vol):</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr>
                                                <td><Label style={{'fontSize': '125%'}}>Retort Content (% by Vol):</Label></td>
                                            </tr>
                                        </tbody>
                                    </Table>
                                </Col>
                                <Col md="7">
                                    <Table>
                                        <thead>
                                            <tr>
                                                <th className="align-center">Water</th>
                                                <th className="align-center">Oil</th>
                                                <th className="align-center">Solids</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr>
                                                <td>
                                                    <EInput
                                                        type="text"
                                                        id="retortContentWater"
                                                        name="retortContentWater"
                                                        data-validation="decimal"
                                                        value={this.state.test.mudProperties.retortContentWater}
                                                        onChange={this.handleInputChange}
                                                    />
                                                </td>
                                                <td>
                                                    <EInput
                                                        type="text"
                                                        id="retortContentOil"
                                                        name="retortContentOil"
                                                        data-validation="decimal"
                                                        value={this.state.test.mudProperties.retortContentOil}
                                                        onChange={this.handleInputChange}
                                                    />
                                                </td>
                                                <td>
                                                    <EInput
                                                        type="text"
                                                        id="retortContentSolids"
                                                        name="retortContentSolids"
                                                        disabled={true}
                                                        value={this.state.test.mudProperties.retortContentSolids}
                                                    />
                                                </td>
                                            </tr>
                                        </tbody>
                                    </Table>
                                </Col>
                                <Col md="12">
                                    <hr/>
                                </Col>
                                { this.state.test.mudProperty === 'Oil Based Mud' ?
                                    <Col md="12">
                                        <Row>
                                            <Col md="12">
                                                <FormGroup row={true}>
                                                    <Label md="6">Oil Ratio</Label>
                                                    <Col md="6">
                                                        <EInput
                                                            type="text"
                                                            id="oilWaterRatioFrom"
                                                            name="oilWaterRatioFrom"
                                                            disabled={true}
                                                            value={this.state.test.mudProperties.oilWaterRatioFrom}
                                                        />
                                                    </Col>
                                                </FormGroup>
                                            </Col>
                                            <Col md="12">
                                                <FormGroup row={true}>
                                                    <Label md="6">Water Ratio</Label>
                                                    <Col md="6">
                                                        <EInput
                                                            type="text"
                                                            id="oilWaterRatioTo"
                                                            name="oilWaterRatioTo"
                                                            disabled={true}
                                                            value={this.state.test.mudProperties.oilWaterRatioTo}
                                                        />
                                                    </Col>
                                                </FormGroup>
                                            </Col>
                                            <Col md="12">
                                                <FormGroup row={true}>
                                                    <Label md="6">Solids Adj for Salt (% by Vol)</Label>
                                                    <Col md="6">
                                                        <EInput
                                                            type="text"
                                                            id="saltVolumePcnt"
                                                            name="saltVolumePcnt"
                                                            disabled={true}
                                                            value={this.state.test.mudProperties.saltVolumePcnt}
                                                        />
                                                    </Col>
                                                </FormGroup>
                                            </Col>
                                            <Col md="12">
                                                <FormGroup row={true}>
                                                    <Label md="6">Mud Alkalinity (pom)</Label>
                                                    <Col md="6">
                                                        <EInput
                                                            type="text"
                                                            id="mudAlkalinityPom"
                                                            name="mudAlkalinityPom"
                                                            data-validation="decimal"
                                                            value={this.state.test.mudProperties.mudAlkalinityPom}
                                                            onChange={this.handleInputChange}
                                                        />
                                                    </Col>
                                                </FormGroup>
                                            </Col>
                                            <Col md="12">
                                                <FormGroup row={true}>
                                                    <Label md="6">Excess Lime (lb/bbl)</Label>
                                                    <Col md="6">
                                                        <EInput
                                                            type="text"
                                                            id="limeContent"
                                                            name="limeContent"
                                                            disabled={true}
                                                            value={this.state.test.mudProperties.limeContent}
                                                        />
                                                    </Col>
                                                </FormGroup>
                                            </Col>
                                            <Col md="12">
                                                <FormGroup row={true}>
                                                    <Label md="6">Versenate (Vom)</Label>
                                                    <Col md="6">
                                                        <EInput
                                                            type="text"
                                                            id="versenate"
                                                            name="versenate"
                                                            data-validation="decimal"
                                                            value={this.state.test.mudProperties.versenate}
                                                            onChange={this.handleInputChange}
                                                        />
                                                    </Col>
                                                </FormGroup>
                                            </Col>
                                            <Col md="12">
                                                <FormGroup row={true}>
                                                    <Label md="6">Salt Water Phase (%/wght)</Label>
                                                    <Col md="6">
                                                        <EInput
                                                            type="text"
                                                            id="saltContentWaterPhase"
                                                            name="saltContentWaterPhase"
                                                            value={this.state.test.mudProperties.saltContentWaterPhase}
                                                            onChange={this.handleInputChange}
                                                            disabled={true}
                                                        />
                                                    </Col>
                                                </FormGroup>
                                            </Col>
                                            <Col md="12">
                                                <FormGroup row={true}>
                                                    <Label md="6">Chloride (Whole Mud)</Label>
                                                    <Col md="6">
                                                        <EInput
                                                            type="text"
                                                            id="chlorideClsn"
                                                            name="chlorideClsn"
                                                            data-validation="decimal"
                                                            value={this.state.test.mudProperties.chlorideClsn}
                                                            onChange={this.handleInputChange}
                                                        />
                                                    </Col>
                                                </FormGroup>
                                            </Col>
                                            <Col md="12">
                                                <FormGroup row={true}>
                                                    <Label md="6">Chloride Ion (mg/L)</Label>
                                                    <Col md="6">
                                                        <EInput
                                                            type="text"
                                                            id="chlorideMgL"
                                                            name="chlorideMgL"
                                                            value={this.state.test.mudProperties.chlorideMgL}
                                                            onChange={this.handleInputChange}
                                                            disabled={true}
                                                        />
                                                    </Col>
                                                </FormGroup>
                                            </Col>
                                            <Col md="12">
                                                <FormGroup row={true}>
                                                    <Label md="6">Electrical Stability (volts)</Label>
                                                    <Col md="6">
                                                        <EInput
                                                            type="text"
                                                            id="electricalStability"
                                                            name="electricalStability"
                                                            data-validation="decimal"
                                                            value={this.state.test.mudProperties.electricalStability}
                                                            onChange={this.handleInputChange}
                                                        />
                                                    </Col>
                                                </FormGroup>
                                            </Col>
                                            <Col md="12">
                                                <FormGroup row={true}>
                                                    <Label md="6">CaCl2 (mg/L) WPS</Label>
                                                    <Col md="6">
                                                        <EInput
                                                            type="text"
                                                            id="cacl2wps"
                                                            name="cacl2wps"
                                                            data-validation="decimal"
                                                            value={this.state.test.mudProperties.cacl2wps}
                                                            disabled="true"
                                                        />
                                                    </Col>
                                                </FormGroup>
                                            </Col>
                                        </Row>
                                    </Col>
                                    :
                                    <Col md="12">
                                        <Row>
                                            <Col md="12">
                                                <FormGroup row={true}>
                                                    <Label md="6">Sand Content (% by Vol)</Label>
                                                    <Col md="6">
                                                        <EInput
                                                            type="text"
                                                            id="sandContent"
                                                            name="sandContent"
                                                            data-validation="decimal"
                                                            value={this.state.test.mudProperties.sandContent}
                                                            onChange={this.handleInputChange}
                                                        />
                                                    </Col>
                                                </FormGroup>
                                            </Col>
                                            <Col md="12">
                                                <FormGroup row={true}>
                                                    <Label md="6">Methylene Blue Test (lb/bbl)</Label>
                                                    <Col md="6">
                                                        <EInput
                                                            type="text"
                                                            id="methyleneBlueTest"
                                                            name="methyleneBlueTest"
                                                            data-validation="decimal"
                                                            value={this.state.test.mudProperties.methyleneBlueTest}
                                                            onChange={this.handleInputChange}
                                                        />
                                                    </Col>
                                                </FormGroup>
                                            </Col>
                                            <Col md="12">
                                                <FormGroup row={true}>
                                                    <Label md="6">Cation Exchange Capacity</Label>
                                                    <Col md="6">
                                                        <EInput
                                                            type="text"
                                                            id="cationExchangeCapacity"
                                                            name="cationExchangeCapacity"
                                                            data-validation="decimal"
                                                            value={this.state.test.mudProperties.cationExchangeCapacity}
                                                            onChange={this.handleInputChange}
                                                        />
                                                    </Col>
                                                </FormGroup>
                                            </Col>
                                            <Col md="12">
                                                <FormGroup row={true}>
                                                    <Label md="6">pH Reading</Label>
                                                    <Col md="6">
                                                        <EInput
                                                            type="text"
                                                            id="pHReading"
                                                            name="pHReading"
                                                            data-validation="decimal"
                                                            value={this.state.test.mudProperties.pHReading}
                                                            onChange={this.handleInputChange}
                                                        />
                                                    </Col>
                                                </FormGroup>
                                            </Col>
                                            <Col md="12">
                                                <FormGroup row={true}>
                                                    <Label md="6">Mud Alkalinity (Pm)</Label>
                                                    <Col md="6">
                                                        <EInput
                                                            type="text"
                                                            id="mudAlkalinityPm"
                                                            name="mudAlkalinityPm"
                                                            data-validation="decimal"
                                                            value={this.state.test.mudProperties.mudAlkalinityPm}
                                                            onChange={this.handleInputChange}
                                                        />
                                                    </Col>
                                                </FormGroup>
                                            </Col>
                                            <Col md="12">
                                                <FormGroup row={true}>
                                                    <Label md="6">Filtrate Alkalinity (Pf)</Label>
                                                    <Col md="6">
                                                        <EInput
                                                            type="text"
                                                            id="filtrateAlkalinityPf"
                                                            name="filtrateAlkalinityPf"
                                                            data-validation="decimal"
                                                            value={this.state.test.mudProperties.filtrateAlkalinityPf}
                                                            onChange={this.handleInputChange}
                                                        />
                                                    </Col>
                                                </FormGroup>
                                            </Col>
                                            <Col md="12">
                                                <FormGroup row={true}>
                                                    <Label md="6">Filtrate Alkalinity (Mf)</Label>
                                                    <Col md="6">
                                                        <EInput
                                                            type="text"
                                                            id="filtrateAlkalinityMf"
                                                            name="filtrateAlkalinityMf"
                                                            data-validation="decimal"
                                                            value={this.state.test.mudProperties.filtrateAlkalinityMf}
                                                            onChange={this.handleInputChange}
                                                        />
                                                    </Col>
                                                </FormGroup>
                                            </Col>
                                            <Col md="12">
                                                <FormGroup row={true}>
                                                    <Label md="6">Chlorides (Mg/L)</Label>
                                                    <Col md="6">
                                                        <EInput
                                                            type="text"
                                                            id="chlorideMgL"
                                                            name="chlorideMgL"
                                                            data-validation="decimal"
                                                            value={this.state.test.mudProperties.chlorideMgL}
                                                            onChange={this.handleInputChange}
                                                        />
                                                    </Col>
                                                </FormGroup>
                                            </Col>
                                            <Col md="12" style={{marginTop: "-2px"}}>
                                                <FormGroup row={true} id="withlabels">
                                                    <Label md="6">Total Hardness mL of Versenate</Label>
                                                    <Col md="6">
                                                        <Table style={{marginTop: "0"}}>
                                                            <tbody>
                                                                <tr>
                                                                    <td>
                                                                        <EInput
                                                                            type="text"
                                                                            id="totalHardnessMl"
                                                                            name="totalHardnessMl"
                                                                            data-validation="decimal"
                                                                            value={this.state.test.mudProperties.totalHardnessMl}
                                                                            onChange={this.handleInputChange}
                                                                        />
                                                                    </td>
                                                                    <td style={{paddingTop: "10px"}}>
                                                                        mL
                                                                    </td>
                                                                    <td>
                                                                        <EInput
                                                                            type="text"
                                                                            id="totalHardness"
                                                                            name="totalHardness"
                                                                            value={this.state.test.mudProperties.totalHardness}
                                                                            disabled={true}
                                                                        />
                                                                    </td>
                                                                    <td style={{paddingTop: "10px"}}>
                                                                        mg/L
                                                                    </td>
                                                                </tr>
                                                            </tbody>
                                                        </Table>
                                                    </Col>                                      
                                                </FormGroup>
                                            </Col>
                                            <Col md="12">
                                                <FormGroup row={true} id="withlabels2">
                                                    <Label md="6">Calcium mL of Versenate</Label>
                                                    <Col md="6">
                                                        <Table style={{marginTop: "0"}}>
                                                            <tbody>
                                                                <tr>
                                                                    <td>
                                                                        <EInput
                                                                            type="text"
                                                                            id="calciumMl"
                                                                            name="calciumMl"
                                                                            data-validation="decimal"
                                                                            value={this.state.test.mudProperties.calciumMl}
                                                                            onChange={this.handleInputChange}
                                                                        />
                                                                    </td>
                                                                    <td style={{paddingTop: "10px"}}>
                                                                        mL
                                                                    </td>
                                                                    <td>
                                                                        <EInput
                                                                            type="text"
                                                                            id="calcium"
                                                                            name="calcium"
                                                                            value={this.state.test.mudProperties.calcium}
                                                                            disabled={true}
                                                                        />
                                                                    </td>
                                                                    <td style={{paddingTop: "10px"}}>
                                                                        mg/L
                                                                    </td>
                                                                </tr>
                                                            </tbody>
                                                        </Table>
                                                    </Col>
                                                </FormGroup>
                                            </Col>
                                            <Col md="12">
                                                <FormGroup row={true}>
                                                    <Label md="6">Magnesium</Label>
                                                    <Col md="6">
                                                        <EInput
                                                            type="text"
                                                            id="magnesium"
                                                            name="magnesium"
                                                            disabled={true}
                                                            value={this.state.test.mudProperties.magnesium}
                                                        />
                                                    </Col>
                                                </FormGroup>
                                            </Col>
                                            <Col md="12">
                                                <FormGroup row={true}>
                                                    <Label md="6">Excess Lime (lb/bbl)</Label>
                                                    <Col md="6">
                                                        <EInput
                                                            type="text"
                                                            id="excessLime"
                                                            name="excessLime"
                                                            disabled={true}
                                                            value={this.state.test.mudProperties.excessLime}
                                                        />
                                                    </Col>
                                                </FormGroup>
                                            </Col>
                                        </Row>
                                    </Col>
                                }
                                <Col md="12">
                                    <hr/>
                                </Col>
                                <Col md="12">
                                    <Table>
                                        <tbody>
                                            <tr>
                                                <td>LCM (lb/bbl):</td>
                                                <td>
                                                    <EInput
                                                        type="text"
                                                        id="lcm"
                                                        name="lcm"
                                                        data-validation="decimal"
                                                        value={this.state.test.mudProperties.lcm}
                                                        onChange={this.handleInputChange}
                                                    />
                                                </td>
                                            </tr>
                                            <tr>
                                                <td>
                                                    <EInput
                                                        name="optionalField1Name"
                                                        id="optionalField1Name"
                                                        type="select"
                                                        value={this.state.test.mudProperties.optionalField1Name}
                                                        onChange={this.handleInputChange}
                                                    >
                                                        <option />
                                                        { this.state.mudTestOptions && this.state.mudTestOptions.map((property: any, index: number) =>
                                                            <option key={index} value={property.fieldItemName}>{property.fieldItemName}</option>
                                                        ) }
                                                    </EInput>
                                                </td>
                                                <td>
                                                    <EInput
                                                        type="text"
                                                        id="optionalField1Value"
                                                        name="optionalField1Value"
                                                        value={this.state.test.mudProperties.optionalField1Value}
                                                        onChange={this.handleInputChange}
                                                    />
                                                </td>
                                            </tr>
                                            <tr>
                                                <td>
                                                    <EInput
                                                        name="optionalField2Name"
                                                        id="optionalField2Name"
                                                        type="select"
                                                        value={this.state.test.mudProperties.optionalField2Name}
                                                        onChange={this.handleInputChange}
                                                    >
                                                        <option />
                                                        { this.state.mudTestOptions && this.state.mudTestOptions.map((property: any, index: number) =>
                                                            <option key={index} value={property.fieldItemName}>{property.fieldItemName}</option>
                                                        ) }
                                                    </EInput>
                                                </td>
                                                <td>
                                                    <EInput
                                                        type="text"
                                                        id="optionalField2Value"
                                                        name="optionalField2Value"
                                                        value={this.state.test.mudProperties.optionalField2Value}
                                                        onChange={this.handleInputChange}
                                                    />
                                                </td>
                                            </tr>
                                        </tbody>
                                    </Table>
                                </Col>
                            </Row>
                        </Col>
                        <Col md="6">
                            <Row>
                                <Col md="12">
                                    <h4>Mud Property Recommendations</h4>
                                    <FormGroup className="required">
                                        <Label>Fluid Type</Label>
                                        <EInput
                                            name="fluidType"
                                            id="fluidType"
                                            type="select"
                                            required={true}
                                            value={this.state.test.mudProperties.fluidType}
                                            onChange={this.handleInputChange}
                                        >
                                            <option disabled={true} />
                                            { this.state.propertyTypes && this.state.propertyTypes[this.state.test.mudProperty]
                                            && this.state.propertyTypes[this.state.test.mudProperty].map((property: IOptionFieldListItem, index: number) =>
                                                <option key={property.id} value={property.fieldItemName}>{property.fieldItemName}</option>
                                            ) }
                                            {
                                                this.state.propertyTypes && this.state.propertyTypes[this.state.test.mudProperty]
                                                && !this.state.propertyTypes[this.state.test.mudProperty].some((property: IOptionFieldListItem, index: number) => property.fieldItemName === this.state.test.mudProperties.fluidType)
                                                && this.state.test.mudProperties.fluidType !== ''
                                                && <option value={this.state.test.mudProperties.fluidType}>{this.state.test.mudProperties.fluidType}</option>
                                            }
                                </EInput>
                                    </FormGroup>
                                </Col>
                                <Col md="6">
                                    <FormGroup>
                                        <Label>Mud Weight (ppg)</Label>
                                        <EInput
                                            type="text"
                                            id="mudWeightPpg"
                                            name="mudWeightPpg"
                                            value={this.state.test.mudProperties.mudWeightPpg}
                                            onChange={this.handleInputChange}
                                        />
                                    </FormGroup>
                                </Col>
                                <Col md="6">
                                    <FormGroup>
                                        <Label>Viscosity (sec/qt)</Label>
                                        <EInput
                                            type="text"
                                            id="viscositySecQt"
                                            name="viscositySecQt"
                                            value={this.state.test.mudProperties.viscositySecQt}
                                            onChange={this.handleInputChange}
                                        />
                                    </FormGroup>
                                </Col>
                                <Col md="12">
                                    <Table>
                                        <tbody>
                                            <tr>
                                                <td>
                                                    <EInput
                                                        name="mudPropOption1"
                                                        id="mudPropOption1"
                                                        type="select"
                                                        value={this.state.test.mudProperties.mudPropOption1}
                                                        onChange={this.handleInputChange}
                                                    >
                                                        <option />
                                                        { this.state.mudPropertyOptions && this.state.mudPropertyOptions.map((property: any, index: number) =>
                                                            <option key={index} value={property.fieldItemName}>{property.fieldItemName}</option>
                                                        ) }
                                                    </EInput>
                                                </td>
                                                <td>
                                                    <EInput
                                                        name="mudPropOption2"
                                                        id="mudPropOption2"
                                                        type="select"
                                                        value={this.state.test.mudProperties.mudPropOption2}
                                                        onChange={this.handleInputChange}
                                                    >
                                                        <option />
                                                        { this.state.mudPropertyOptions && this.state.mudPropertyOptions.map((property: any, index: number) =>
                                                            <option key={index} value={property.fieldItemName}>{property.fieldItemName}</option>
                                                        ) }
                                                    </EInput>
                                                </td>
                                                <td>
                                                    <EInput
                                                        name="mudPropOption3"
                                                        id="mudPropOption3"
                                                        type="select"
                                                        value={this.state.test.mudProperties.mudPropOption3}
                                                        onChange={this.handleInputChange}
                                                    >
                                                        <option />
                                                        { this.state.mudPropertyOptions && this.state.mudPropertyOptions.map((property: any, index: number) =>
                                                            <option key={index} value={property.fieldItemName}>{property.fieldItemName}</option>
                                                        ) }
                                                    </EInput>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td>
                                                    <EInput
                                                        type="text"
                                                        id="mudPropValue1"
                                                        name="mudPropValue1"
                                                        value={this.state.test.mudProperties.mudPropValue1}
                                                        onChange={this.handleInputChange}
                                                    />
                                                </td>
                                                <td>
                                                    <EInput
                                                        type="text"
                                                        id="mudPropValue2"
                                                        name="mudPropValue2"
                                                        value={this.state.test.mudProperties.mudPropValue2}
                                                        onChange={this.handleInputChange}
                                                    />
                                                </td>
                                                <td>
                                                    <EInput
                                                        type="text"
                                                        id="mudPropValue3"
                                                        name="mudPropValue3"
                                                        value={this.state.test.mudProperties.mudPropValue3}
                                                        onChange={this.handleInputChange}
                                                    />
                                                </td>
                                            </tr>
                                        </tbody>
                                    </Table>
                                </Col>
                            </Row>
                            <Row>
                                <Col md="12">
                                    <h4 className="stacked-h4">Rheology / Hydraulics</h4>
                                </Col>
                                <Col md="6">
                                    <FormGroup>
                                        <Label>Plastic Viscosity</Label>
                                        <EInput
                                            type="text"
                                            id="plasticViscosity"
                                            name="plasticViscosity"
                                            value={this.state.test.mudProperties.plasticViscosity}
                                            disabled={true}
                                        />
                                    </FormGroup>
                                    <FormGroup>
                                        <Label>Yield Point</Label>
                                        <EInput
                                            type="text"
                                            id="yeildPoint"
                                            name="yeildPoint"
                                            value={this.state.test.mudProperties.yeildPoint}
                                            disabled={true}
                                        />
                                    </FormGroup>
                                    <FormGroup>
                                        <Label>Mud Gradient</Label>
                                        <EInput
                                            type="text"
                                            id="mudGradient"
                                            name="mudGradient"
                                            value={this.state.test.mudProperties.mudGradient}
                                            disabled={true}
                                        />
                                    </FormGroup>
                                    <FormGroup>
                                        <Label>AVDP (fps)</Label>
                                        <EInput
                                            type="text"
                                            id="effectiveViscosity"
                                            name="effectiveViscosity"
                                            value={(Number(this.state.test.pumpData.avdp) / 60).toFixed(2)}
                                            disabled={true}
                                        />
                                    </FormGroup>
                                    <FormGroup>
                                        <Label>N Value</Label>
                                        <EInput
                                            type="text"
                                            id="nValue"
                                            name="nValue"
                                            value={this.state.test.mudProperties.nValue}
                                            disabled={true}
                                        />
                                    </FormGroup>
                                    <FormGroup>
                                        <Label>ECD (ppg)</Label>
                                        <EInput
                                            type="text"
                                            id="ecd"
                                            name="ecd"
                                            value={this.state.test.mudProperties.ecd}
                                            disabled={true}
                                        />
                                    </FormGroup>

                                    
                                </Col>
                                <Col md="6">
                                    <FormGroup>
                                        <Label>Surge Pressure (ppg)</Label>
                                        <EInput
                                            type="text"
                                            id="surgePressure"
                                            name="surgePressure"
                                            value={this.state.test.mudProperties.surgePressure}
                                            disabled={true}
                                        />
                                    </FormGroup>
                                    <FormGroup>
                                        <Label>Swab Pressure (ppg)</Label>
                                        <EInput
                                            type="text"
                                            id="swabPressure"
                                            name="swabPressure"
                                            value={this.state.test.mudProperties.swabPressure}
                                            disabled={true}
                                        />
                                    </FormGroup>
                                    <FormGroup>
                                        <Label>Hydrostatic Psi</Label>
                                        <EInput
                                            type="text"
                                            id="hydrostaticPsi"
                                            name="hydrostaticPsi"
                                            value={this.state.test.mudProperties.hydrostaticPsi}
                                            disabled={true}
                                        />
                                    </FormGroup>
                                    <FormGroup>
                                        <Label>Effective Viscosity (centipoise)</Label>
                                        <EInput
                                            type="text"
                                            id="effectiveViscosity"
                                            name="effectiveViscosity"
                                            value={this.state.test.mudProperties.effectiveViscosity}
                                            disabled={true}
                                        />
                                    </FormGroup>
                                    <FormGroup>
                                        <Label>K Value</Label>
                                        <EInput
                                            type="text"
                                            id="kValue"
                                            name="kValue"
                                            value={this.state.test.mudProperties.kValue}
                                            disabled={true}
                                        />
                                    </FormGroup>
                                    <FormGroup>
                                        <Label>Reynolds #</Label>
                                        <EInput
                                            type="text"
                                            id="reynoldsNbr"
                                            name="reynoldsNbr"
                                            value={this.state.test.mudProperties.reynoldsNbr}
                                            disabled={true}
                                        />
                                    </FormGroup>
                                </Col>
                            </Row>
                            <Row>
                                <Col md="12">
                                    <h4 className="stacked-h4">Solids</h4>
                                </Col>
                                <Col md="12">
                                    { this.state.test.mudProperty === 'Oil Based Mud' ?
                                        <Row>
                                            <Col md="12">
                                                {/* <FormGroup row={true}>
                                                    <Label md="6">Oil, sg</Label>
                                                    <Col md="6">
                                                        <EInput
                                                            type="text"
                                                            id="oilSg"
                                                            name="oilSg"
                                                            value={this.state.test.mudProperties.oilSg}
                                                            onChange={this.handleInputChange}
                                                        />
                                                    </Col>
                                                </FormGroup>
                                            </Col>
                                            <Col md="12">
                                                <FormGroup row={true}>
                                                    <Label md="6">Drill Solids, sg</Label>
                                                    <Col md="6">
                                                        <EInput
                                                            type="text"
                                                            id="drillSolidsSg"
                                                            name="drillSolidsSg"
                                                            value={this.state.test.mudProperties.drillSolidsSg}
                                                            onChange={this.handleInputChange}
                                                        />
                                                    </Col>
                                                </FormGroup>
                                            </Col>
                                            <Col md="12">
                                                <FormGroup row={true}>
                                                    <Label md="6">Wght Matl, sg</Label>
                                                    <Col md="6">
                                                        <EInput
                                                            type="text"
                                                            id="wghtMatlSg"
                                                            name="wghtMatlSg"
                                                            value={this.state.test.mudProperties.wghtMatlSg}
                                                            onChange={this.handleInputChange}
                                                        />
                                                    </Col>
                                                </FormGroup>
                                            </Col>
                                            <Col md="12">
                                                <FormGroup row={true}>
                                                    <Label md="6">Average Specific Gravity</Label>
                                                    <Col md="6">
                                                        <EInput
                                                            type="text"
                                                            id="asg"
                                                            name="asg"
                                                            value={this.state.test.mudProperties.asg}
                                                            disabled={true}
                                                        />
                                                    </Col>
                                                </FormGroup>
                                            </Col>
                                            <Col md="12"> */}
                                                <Table>
                                                    <tbody>
                                                        <tr>
                                                            <td>
                                                                <Label className="required">
                                                                    Weighting Agent
                                                                </Label>
                                                            </td>
                                                            <td style={{width: '40%'}}/>
                                                            <td style={{width: '40%'}}>
                                                                <EInput
                                                                    type="select"
                                                                    id="weightingAgent"
                                                                    name="weightingAgent"
                                                                    required={true}
                                                                    value={this.state.test.mudProperties.weightingAgentId}
                                                                    onChange={this.handleWeightingChange}
                                                                >
                                                                    <option disabled={true} />
                                                                    {
                                                                        this.state.weightingAgentOptions.map((value: IProduct) => 
                                                                            <option key={value.id} value={value.id}>{value.name}</option>
                                                                        )
                                                                    }
                                                                </EInput>
                                                            </td>
                                                        </tr>
                                                        <tr>
                                                        <td>
                                                            {
                                                                canEditSg &&
                                                                <Input
                                                                    style={{
                                                                        margin: '0 5px 0 0'
                                                                    }}
                                                                    type="checkbox"
                                                                    name="oilSgOverride"
                                                                    id="oilSgOverride"
                                                                    checked={this.state.test.mudProperties.oilSgOverride}
                                                                    onChange={this.handleUserOverride}
                                                                />
                                                            }
                                                                Oil, sg
                                                            </td>
                                                            <td style={{width: '40%'}}/>
                                                            <td style={{width: '40%'}}>
                                                                <EInput
                                                                    style={canEditSg ? editableBlueStyle : {}}
                                                                    type="text"
                                                                    id="oilSg"
                                                                    name="oilSg"
                                                                    data-validation="decimal"
                                                                    value={this.state.test.mudProperties.oilSg}
                                                                    onChange={this.handleInputChange}
                                                                    disabled={!canEditSg || !this.state.test.mudProperties.oilSgOverride}
                                                                />
                                                            </td>
                                                        </tr>
                                                        <tr>
                                                            <td>
                                                            {
                                                                canEditSg &&
                                                                    <Input
                                                                        style={{
                                                                            margin: '0 5px 0 0'
                                                                        }}
                                                                        type="checkbox"
                                                                        name="drillSolidsSgOverride"
                                                                        id="drillSolidsSgOverride"
                                                                        checked={this.state.test.mudProperties.drillSolidsSgOverride}
                                                                        onChange={this.handleUserOverride}
                                                                    />
                                                            }
                                                                Drill Solids, sg
                                                            </td>
                                                            <td/>
                                                            <td>
                                                                <EInput
                                                                    style={canEditSg ? editableBlueStyle : {}}
                                                                    type="text"
                                                                    id="drillSolidsSg"
                                                                    name="drillSolidsSg"
                                                                    data-validation="decimal"
                                                                    value={this.state.test.mudProperties.drillSolidsSg}
                                                                    onChange={this.handleInputChange}
                                                                    disabled={!canEditSg || !this.state.test.mudProperties.drillSolidsSgOverride}
                                                                />
                                                            </td>
                                                        </tr>
                                                        <tr>
                                                            <td>
                                                            {
                                                                canEditSg &&
                                                                    <Input
                                                                        style={{
                                                                            margin: '0 5px 0 0'
                                                                        }}
                                                                        type="checkbox"
                                                                        name="wghtMatlSgOverride"
                                                                        id="wghtMatlSgOverride"
                                                                        checked={this.state.test.mudProperties.wghtMatlSgOverride}
                                                                        onChange={this.handleUserOverride}
                                                                    />
                                                            }
                                                                Wght Matl, sg
                                                            </td>
                                                            <td/>
                                                            <td>
                                                                <EInput
                                                                    style={canEditSg ? editableBlueStyle : {}}
                                                                    type="text"
                                                                    id="wghtMatlSg"
                                                                    name="wghtMatlSg"
                                                                    data-validation="decimal"
                                                                    value={this.state.test.mudProperties.wghtMatlSg}
                                                                    onChange={this.handleInputChange}
                                                                    disabled={!canEditSg || !this.state.test.mudProperties.wghtMatlSgOverride}
                                                                />
                                                            </td>
                                                        </tr>
                                                        <tr>
                                                            <td>
                                                                Average Specific Gravity
                                                            </td>
                                                            <td/>
                                                            <td>
                                                                <EInput
                                                                    type="text"
                                                                    id="asg"
                                                                    name="asg"
                                                                    value={this.state.test.mudProperties.asg}
                                                                    disabled={true}
                                                                />
                                                            </td>
                                                        </tr>
                                                        <tr>
                                                            <td/>
                                                            <td className="align-center">%</td>
                                                            <td className="align-center">Lb/bbl</td>
                                                        </tr>
                                                        <tr>
                                                            <td>Low Gravity:</td>
                                                            <td>
                                                                <EInput
                                                                    type="text"
                                                                    id="lowGravityPcnt"
                                                                    name="lowGravityPcnt"
                                                                    value={this.state.test.mudProperties.lowGravityPcnt}
                                                                    disabled={true}
                                                                />
                                                            </td>
                                                            <td>
                                                                <EInput
                                                                    type="text"
                                                                    id="lowGravityLbBbl"
                                                                    name="lowGravityLbBbl"
                                                                    value={this.state.test.mudProperties.lowGravityLbBbl}
                                                                    disabled={true}
                                                                />
                                                            </td>
                                                        </tr>
                                                        <tr>
                                                            <td>High Gravity:</td>
                                                            <td>
                                                                <EInput
                                                                    type="text"
                                                                    id="highGravityPcnt"
                                                                    name="highGravityPcnt"
                                                                    value={this.state.test.mudProperties.highGravityPcnt}
                                                                    disabled={true}
                                                                />
                                                            </td>
                                                            <td>
                                                                <EInput
                                                                    type="text"
                                                                    id="highGravityLbBbl"
                                                                    name="highGravityLbBbl"
                                                                    value={this.state.test.mudProperties.highGravityLbBbl}
                                                                    disabled={true}
                                                                />
                                                            </td>
                                                        </tr>
                                                    </tbody>
                                                </Table>
                                            </Col>
                                        </Row>
                                            : 
                                        <Row>
                                            {/* <Col md="12">
                                                <FormGroup row={true}>
                                                    <Label md="6">Oil, sg</Label>
                                                    <Col md="6">
                                                        <EInput
                                                            type="text"
                                                            id="oilSg"
                                                            name="oilSg"
                                                            value={this.state.test.mudProperties.oilSg}
                                                            onChange={this.handleInputChange}
                                                        />
                                                    </Col>
                                                </FormGroup>
                                            </Col>
                                            <Col md="12">
                                                <FormGroup row={true}>
                                                    <Label md="6">Low Gravity Solid, sg</Label>
                                                    <Col md="6">
                                                        <EInput
                                                            type="text"
                                                            id="drillSolidsSg"
                                                            name="drillSolidsSg"
                                                            value={this.state.test.mudProperties.drillSolidsSg}
                                                            onChange={this.handleInputChange}
                                                        />
                                                    </Col>
                                                </FormGroup>
                                            </Col>
                                            <Col md="12">
                                                <FormGroup row={true}>
                                                    <Label md="6">Wght Matl, sg</Label>
                                                    <Col md="6">
                                                        <EInput
                                                            type="text"
                                                            id="wghtMatlSg"
                                                            name="wghtMatlSg"
                                                            value={this.state.test.mudProperties.wghtMatlSg}
                                                            onChange={this.handleInputChange}
                                                        />
                                                    </Col>
                                                </FormGroup>
                                            </Col>
                                            <Col md="12">
                                                <FormGroup>
                                                    <Label>ASG</Label>
                                                    <EInput
                                                        type="text"
                                                        id="asg"
                                                        name="asg"
                                                        value={this.state.test.mudProperties.asg}
                                                        disabled={true}
                                                    />
                                                </FormGroup>
                                            </Col> */}
                                            <Col md="12">
                                                <Table>
                                                    <tbody>
                                                        {
                                                            this.state.test.weighted === true &&
                                                            <tr>
                                                                <td>
                                                                    <Label className="required">
                                                                        Weighting Agent
                                                                    </Label>
                                                                </td>
                                                                <td style={{width: '40%'}}/>
                                                                <td style={{width: '40%'}}>
                                                                    <EInput
                                                                        type="select"
                                                                        id="weightingAgent"
                                                                        name="weightingAgent"
                                                                        required={true}
                                                                        value={this.state.test.mudProperties.weightingAgentId}
                                                                        onChange={this.handleWeightingChange}
                                                                    >
                                                                        <option disabled={true} />
                                                                        {
                                                                            this.state.weightingAgentOptions.map((value: IProduct) => 
                                                                                <option key={value.id} value={value.id}>{value.name}</option>
                                                                            )
                                                                        }
                                                                    </EInput>
                                                                </td>
                                                            </tr>
                                                        }
                                                        <tr>
                                                            <td>
                                                            {
                                                                canEditSg &&
                                                                <Input
                                                                    style={{
                                                                        margin: '0 5px 0 0'
                                                                    }}
                                                                    type="checkbox"
                                                                    name="oilSgOverride"
                                                                    id="oilSgOverride"
                                                                    checked={this.state.test.mudProperties.oilSgOverride}
                                                                    onChange={this.handleUserOverride}
                                                                />
                                                            }
                                                                Oil, sg
                                                            </td>
                                                            <td style={{width: '40%'}}/>
                                                            <td style={{width: '40%'}}>
                                                                <EInput
                                                                    style={canEditSg ? editableBlueStyle : {}}
                                                                    type="text"
                                                                    id="oilSg"
                                                                    name="oilSg"
                                                                    data-validation="decimal"
                                                                    value={this.state.test.mudProperties.oilSg}
                                                                    onChange={this.handleInputChange}
                                                                    disabled={!canEditSg || !this.state.test.mudProperties.oilSgOverride}
                                                                />
                                                            </td>
                                                        </tr>
                                                        <tr>
                                                            <td>
                                                            {
                                                                canEditSg &&
                                                                    <Input
                                                                        style={{
                                                                            margin: '0 5px 0 0'
                                                                        }}
                                                                        type="checkbox"
                                                                        name="drillSolidsSgOverride"
                                                                        id="drillSolidsSgOverride"
                                                                        checked={this.state.test.mudProperties.drillSolidsSgOverride}
                                                                        onChange={this.handleUserOverride}
                                                                    />
                                                            }
                                                                Low Gravity Solid, sg
                                                            </td>
                                                            <td/>
                                                            <td>
                                                                <EInput
                                                                    style={canEditSg ? editableBlueStyle : {}}
                                                                    type="text"
                                                                    id="drillSolidsSg"
                                                                    name="drillSolidsSg"
                                                                    data-validation="decimal"
                                                                    value={this.state.test.mudProperties.drillSolidsSg}
                                                                    onChange={this.handleInputChange}
                                                                    disabled={!canEditSg || !this.state.test.mudProperties.drillSolidsSgOverride}
                                                                />
                                                            </td>
                                                        </tr>
                                                        <tr>
                                                            <td>
                                                            {
                                                                canEditSg &&
                                                                    <Input
                                                                        style={{
                                                                            margin: '0 5px 0 0'
                                                                        }}
                                                                        type="checkbox"
                                                                        name="wghtMatlSgOverride"
                                                                        id="wghtMatlSgOverride"
                                                                        checked={this.state.test.mudProperties.wghtMatlSgOverride}
                                                                        onChange={this.handleUserOverride}
                                                                    />
                                                            }
                                                                Wght Matl, sg
                                                            </td>
                                                            <td/>
                                                            <td>
                                                                <EInput
                                                                    style={canEditSg ? editableBlueStyle : {}}
                                                                    type="text"
                                                                    id="wghtMatlSg"
                                                                    name="wghtMatlSg"
                                                                    data-validation="decimal"
                                                                    value={this.state.test.mudProperties.wghtMatlSg}
                                                                    onChange={this.handleInputChange}
                                                                    disabled={!canEditSg || !this.state.test.mudProperties.wghtMatlSgOverride}
                                                                />
                                                            </td>
                                                        </tr>
                                                        {/* Removed MUD-3027
                                                        { showWeighted && 
                                                        <tr>
                                                            <td>
                                                                Unweighted ASG
                                                            </td>
                                                            <td/>
                                                            <td>
                                                                <EInput
                                                                    type="text"
                                                                    id="unweightedASG"
                                                                    name="unweightedASG"
                                                                    data-validation="decimal"
                                                                    value={this.state.test.mudProperties.unweightedASG}
                                                                    onChange={this.handleInputChange}
                                                                />
                                                            </td>
                                                        </tr>
                                                        } */}
                                                        <tr>
                                                            <td>
                                                                ASG
                                                            </td>
                                                            <td/>
                                                            <td>
                                                                <EInput
                                                                    type="text"
                                                                    id="asg"
                                                                    name="asg"
                                                                    value={this.state.test.mudProperties.asg}
                                                                    disabled={true}
                                                                />
                                                            </td>
                                                        </tr>
                                                        {/* Removed MUD-3027
                                                        { showWeighted && 
                                                        <tr>
                                                            <td colSpan={3}>
                                                                <Input
                                                                    style={{
                                                                        margin: '0 5px 0 0'
                                                                    }}
                                                                    type="checkbox"
                                                                    name="showNormalASG"
                                                                    id="showNormalASG"
                                                                    checked={this.state.test.mudProperties.showNormalASG}
                                                                    onChange={this.handleUserOverride}
                                                                />
                                                                Show ASG on Report instead of Unweighted ASG
                                                            </td>
                                                        </tr>
                                                        } */}
                                                        <tr>
                                                            <td/>
                                                            <td className="align-center">%</td>
                                                            <td className="align-center">Lb/bbl</td>
                                                        </tr>
                                                        <tr>
                                                            <td>Low Gravity:</td>
                                                            <td>
                                                                <EInput
                                                                    type="text"
                                                                    id="lowGravityPcnt"
                                                                    name="lowGravityPcnt"
                                                                    value={this.state.test.mudProperties.lowGravityPcnt}
                                                                    disabled={true}
                                                                />
                                                            </td>
                                                            <td>
                                                                <EInput
                                                                    type="text"
                                                                    id="lowGravityLbBbl"
                                                                    name="lowGravityLbBbl"
                                                                    value={this.state.test.mudProperties.lowGravityLbBbl}
                                                                    disabled={true}
                                                                />
                                                            </td>
                                                        </tr>
                                                        <tr>
                                                            <td>High Gravity:</td>
                                                            <td>
                                                                <EInput
                                                                    type="text"
                                                                    id="highGravityPcnt"
                                                                    name="highGravityPcnt"
                                                                    value={this.state.test.mudProperties.highGravityPcnt}
                                                                    disabled={true}
                                                                />
                                                            </td>
                                                            <td>
                                                                <EInput
                                                                    type="text"
                                                                    id="highGravityLbBbl"
                                                                    name="highGravityLbBbl"
                                                                    value={this.state.test.mudProperties.highGravityLbBbl}
                                                                    disabled={true}
                                                                />
                                                            </td>
                                                        </tr>
                                                        <tr>
                                                            <td>Bentonite:</td>
                                                            <td>
                                                                <EInput
                                                                    type="text"
                                                                    id="bentonitePcnt"
                                                                    name="bentonitePcnt"
                                                                    value={this.state.test.mudProperties.bentonitePcnt}
                                                                    disabled={true}
                                                                />
                                                            </td>
                                                            <td>
                                                                <EInput
                                                                    type="text"
                                                                    id="bentoniteLbBbl"
                                                                    name="bentoniteLbBbl"
                                                                    value={this.state.test.mudProperties.bentoniteLbBbl}
                                                                    disabled={true}
                                                                />
                                                            </td>
                                                        </tr>
                                                        <tr>
                                                            <td>Drill Solids:</td>
                                                            <td>
                                                                <EInput
                                                                    type="text"
                                                                    id="drillSolidsPcnt"
                                                                    name="drillSolidsPcnt"
                                                                    value={this.state.test.mudProperties.drillSolidsPcnt}
                                                                    disabled={true}
                                                                />
                                                            </td>
                                                            <td>
                                                                <EInput
                                                                    type="text"
                                                                    id="drillSolidsLbBbl"
                                                                    name="drillSolidsLbBbl"
                                                                    value={this.state.test.mudProperties.drillSolidsLbBbl}
                                                                    disabled={true}
                                                                />
                                                            </td>
                                                        </tr>
                                                        <tr>
                                                            <td>Salt % Vol:</td>
                                                            <td>
                                                                <EInput
                                                                    type="text"
                                                                    id="saltVolumePcnt"
                                                                    name="saltVolumePcnt"
                                                                    value={this.state.test.mudProperties.saltVolumePcnt}
                                                                    disabled={true}
                                                                />
                                                            </td>
                                                            <td />
                                                        </tr>
                                                        {
                                                            this.state.test.propertyType === "Brine Emulsion" &&
                                                        <tr>
                                                            <td>Salt % Adjusted for Water Vol:</td>
                                                            <td>
                                                                <EInput
                                                                    type="text"
                                                                    id="saltVolumeAdjPcnt"
                                                                    name="saltVolumeAdjPcnt"
                                                                    value={this.state.test.mudProperties.saltVolumeAdjPcnt}
                                                                    disabled={true}
                                                                />
                                                            </td>
                                                            <td />
                                                        </tr>
                                                        }
                                                    </tbody>
                                                </Table>
                                            </Col>
                                        </Row>
                                    }
                                </Col>
                            </Row>
                        </Col>
                    </Row>
                </Form>
                <Footer well={this.WellsStore.well} test={this.TestsStore.test} onSave={this.updateTestModel} onNavigate={this.buttonNavigation} saveGrey={this.otherTimeBlank()} />
            </div>
        );
    }
}

export default withRouter(MudProperties);



// WEBPACK FOOTER //
// ./src/Components/Main/TestWorkflow/FluidData/MudProperties/MudProperties.tsx